export default __webpack_public_path__ + "32d5b0c8be6036abecaa69adc5961355.png";